import React, { useCallback, useState, useEffect } from 'react'
import { colors } from '../../../styles/colors'
import styled from 'styled-components'
import instMgmtApi from '../../../utils/api/instanceMgmt/instMgmtApi'
import { makeCall } from '../../../utils/api/makeCall'


const StyledReportTypesList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    cursor: pointer;
    padding: 15px 25px;
    border-bottom: 1px solid ${colors.gray2};
  }
`
const WashReportTypeList = ({ onClickCreateNewReport }) => {
  const [, setErrorStates] = useState({})
  const [, setLoadingStates] = useState({})
  const [reports, setReports] = useState([])
  const handleClickCreateNew = useCallback(reportType => () => {
    onClickCreateNewReport(reportType)
  }, [onClickCreateNewReport])
  const loadReports = async () => {
    await makeCall('washReportJobTypes', async () => {
      var result = await instMgmtApi.getWashReportJobTypes()
      setReports(result)
  }, setErrorStates, setLoadingStates)
}
  useEffect(() => {
    loadReports()
  }, [])
  return (
    <StyledReportTypesList>
      {reports.map(reportType => (
        <li key={reportType.id} onClick={handleClickCreateNew(reportType)}>{reportType.displayName}</li>
      ))}
    </StyledReportTypesList>
  )
}

export default WashReportTypeList
